import React, { useEffect } from 'react'
import { Field, useForm, useFormState } from 'react-final-form'
import { Box, TextField } from '@mui/material'
import CustomCheckbox from 'src/common/components/CustomCheckbox'

const validateUrl = value => {
  if (!value) return 'URL is required'
  if (value.includes('.')) {
    return undefined
  } else {
    return 'Please enter a valid URL (e.g. example.com)'
  }
}

export default function SecondStepOptionsForm() {
  const { values } = useFormState()
  const form = useForm()

  const { skipMicroLearning } = values

  useEffect(() => {
    if (values?.skipSecondStep === false) {
      form.change('skipSecondStep', false)
    } else {
      form.change('skipSecondStep', true)
    }

    if (!skipMicroLearning) {
      form.change('skipMicroLearning', false)
    }
    if (!values?.redirectUrl) {
      form.change('redirectUrl', null)
    }
  }, [])

  useEffect(() => {
    if (!skipMicroLearning) {
      form.change('redirectUrl', null)
    } else {
      form.change('redirectUrl', values?.redirectUrl || window._env_.REACT_USER_APP_HOST)
    }
  }, [skipMicroLearning])

  return (
    (values.type === 'MANUAL_EMAIL' || values.type === 'AUTOMATED_EMAIL' || values.type === 'AUTOMATED_AI_EMAIL') && (
      <Box sx={{ pt: 3 }} display={'flex'} flexDirection={'column'} rowGap={1}>
        <p style={{ color: '#76767F', fontWeight: 500 }} fontSize={'16px'} fontFamily={'Plus Jakarta Sans'}>
          After-phish actions
        </p>
        <div className='row row-center'>
          <Field
            type={'checkbox'}
            name={'skipSecondStep'}
            render={({ input }) => {
              return <CustomCheckbox onChange={input.onChange} checked={input.checked} />
            }}
          />
          <p style={{ marginRight: 20 }}>Skip login step</p>
          <Field
            type={'checkbox'}
            name={'skipMicroLearning'}
            render={({ input }) => <CustomCheckbox onChange={input.onChange} checked={input.checked} />}
          />
          <p>Skip micro learning</p>
        </div>

        {values.skipMicroLearning && (
          <>
            <p style={{ color: '#76767F', fontWeight: 500, marginTop: 20 }}>After-phish redirect URL</p>
            <Field
              name={'redirectUrl'}
              validate={validateUrl}
              render={({ input, meta }) => (
                <>
                  <TextField
                    name={'redirectUrl'}
                    value={input.value}
                    onChange={input.onChange}
                    onBlur={input.onBlur}
                    error={meta.touched && meta.error}
                    helperText={meta.touched && meta.error}
                    required
                    sx={{
                      backgroundColor: '#fff',
                      borderRadius: '12px',
                      '& .MuiInputBase-root': { borderRadius: '12px' }
                    }}
                    placeholder='Redirect URL'
                  />
                </>
              )}
            />
          </>
        )}
      </Box>
    )
  )
}
